import React from "react";
import FeaturedImage from "../FeaturedImage";

function post(props) {
  const { post, postType, displayCategories, replaceSelected } = props;

  let categories;
  let categoriesInfo;
  let locations;
  let locationsInfo;
  let featuredImage;
  let appointmentLink;
  let profileLink;

  if (post.hasOwnProperty("featured_image") && post.featured_image) {
    featuredImage = (
      <figure className="doctor-card__img">
        <a className="hover" href={post.link}>
          <FeaturedImage
            imageSize={"square-medium"}
            image={post.featured_image}
            srcset={post.featured_image}
          ></FeaturedImage>
        </a>
      </figure>
    );
  } else if (post.acf_data.default_image) {
    featuredImage = (
      <figure className="doctor-card__img">
        <a
          className="hover"
          href={post.link}
          dangerouslySetInnerHTML={{ __html: post.acf_data.default_image }}
        ></a>
      </figure>
    );
  } else {
    featuredImage = <span className="doctor-card__img-placeholder"></span>;
  }

  if (post.hasOwnProperty("the_categories") && post.the_categories.length > 0) {
    categories = post.the_categories;
  }

  if (categories && displayCategories) {
    categoriesInfo = (
      <div className="doctor-card__info">
        <p className="doctor-card__subheading">Services</p>
        <div className="doctor-card__terms terms">
          <ul className="terms-list">
            {categories.map((category) => {
              return (
                <li className="terms-list__item" key={category.id}>
                  <a
                    className="terms-list__link"
                    onClick={() => {
                      replaceSelected(category.id, category.taxonomy);
                    }}
                  >
                    <span className="terms__single">{category.name}</span>
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }

  if (post.hasOwnProperty("acf_data") && post.acf_data.locations.length > 0) {
    locations = post.acf_data.locations;
  }

  if (locations) {
    locationsInfo = (
      <div className="doctor-card__info">
        <p className="doctor-card__subheading">Locations</p>
        <ul className="doctor-card__locations terms-list">
          {locations.map((location) => {
            return (
              <li
                className="doctor-card__locations-item terms-list__item"
                key={location.id}
              >
                <a
                  className="doctor-card__locations-link terms-list__link"
                  target="_blank"
                  href={location.link}
                >
                  {location.name}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  if (post.hasOwnProperty("acf_data") && post.acf_data.appointment_link) {
    const link = post.acf_data.appointment_link;
    appointmentLink = (
      <div className="c-btn-wrapper text-left text-md-left">
        <a
          href={link.url}
          className="c-btn c-btn-primary c-btn-color-normal"
          target={link.target}
        >
          <span>{link.title}</span>
        </a>
      </div>
    );
  }

  profileLink = (
    <div className="c-btn-wrapper text-left text-md-left">
      <a
        href={post.link}
        className="c-btn c-btn-secondary c-btn-color-normal hover"
        target="_blank"
      >
        <span>View Profile</span>
      </a>
    </div>
  );

  return (
    <article
      id={`${postType}-${post.id}`}
      className="doctor-card hover-wrapper"
    >
      <div className="doctor-card__wrapper">
        {featuredImage}
        <div className="doctor-card__content">
          <div className="doctor-card__top">
            <h3 className="doctor-card__title">
              <a className="hover" href={post.link}>
                {post.title.rendered}
              </a>
            </h3>
            {categoriesInfo}
            {locationsInfo}
          </div>
          <div className="doctor-card__buttons c-btn-group">
            {appointmentLink}
            {profileLink}
          </div>
        </div>
      </div>
    </article>
  );
}

export default post;
